<template>
  <b-row class="form-summary-wrap">
    <b-col class="form-summary-group">
      <b-form-group :label="$t('Total value')" label-for="total-value">
        <b-input-group class="custom-input-group" prepend="€">
          <b-form-input
            class="custom-input"
            id="total-value"
            :value="totalValue"
            type="text"
            trim
            @change="(value) => change('totalValue', value)"
          ></b-form-input>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col class="form-summary-group">
      <b-form-group :label="$t('Total weight')" label-for="total-weight">
        <b-input-group class="custom-input-group" append="kg">
          <b-form-input
            class="custom-input"
            id="total-weight"
            type="text"
            :value="totalWeight"
            @change="(value) => change('totalWeight', value)"
            trim
          ></b-form-input>
        </b-input-group>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "CN23ValueSummary",
  props: ["totalWeight", "totalValue"],
  methods: {
    change(property, value) {
      this.$emit("change", { property, value });
    },
  },
};
</script>

<style scoped>
.form-summary-wrap {
  max-width: 591px;
  min-height: 101px;
  margin: 45px 0px 0px 0px;
  line-height: 1em;
}

.form-summary-group {
  position: relative;
  width: 25%;
  min-height: 59px;
  margin: 0px 0px 20px 0px;
  padding: 0px 10px 0px 0px;
  line-height: 1em;
}
</style>
